
var sliderInfNotiSecMed = tns({
	"container": ".slider-sliderSliNotiSecSm",
	"controlsContainer": ".slider-sliderSliNotiSecSm-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"controls": false,
	"navPosition": "bottom",
	"mouseDrag": true,
	"speed": 400,
	"center": false,
	"slideBy": 1,
	"fixedWidth": 270,
	"gutter": 16,
	"loop": false,
	"responsive": {
		"768": {
			"slideBy": 1,
			"controls": false,
			"fixedWidth": 290,
			"gutter": 32
		},
		"1280": {
			"slideBy": 1,
			"controls": true,
			"fixedWidth": 290,
			"gutter": 64
		},
		"1600": {
			"slideBy": 1,
			"controls": true,
			"fixedWidth": 290,
			"gutter": 64
		}
	}
});

var sliderInfNotiSecMedRating = tns({
	"container": ".slider-sliderSliNotiSecSmRating",
	"controlsContainer": ".slider-sliderSliNotiSecSmRating-controls",
	"preventScrollOnTouch": "force",
	"controlsPosition": "bottom",
	"controls": false,
	"navPosition": "bottom",
	"mouseDrag": true,
	"speed": 400,
	"center": false,
	"slideBy": 1,
	"fixedWidth": 270,
	"gutter": 16,
	"loop": false,
	"responsive": {
		"768": {
			"slideBy": 1,
			"controls": false,
			"fixedWidth": 290,
			"gutter": 32
		},
		"1280": {
			"slideBy": 1,
			"controls": true,
			"fixedWidth": 290,
			"gutter": 64
		},
		"1600": {
			"slideBy": 1,
			"controls": true,
			"fixedWidth": 290,
			"gutter": 64
		}
	}
});
